import React, { FC, MouseEvent, useCallback, useMemo } from 'react'

import { NumberDirection } from 'common-constants/numbers'
import {
  ArrowLeft,
  ArrowRight,
  Arrows,
} from 'components/presentational/Arrows/Arrows'
import { fullStopPropagation } from 'functions/fullStopPropagation'
import { mergeAllUrls } from 'functions/mergeAllUrls'

import { usePhotoViewerContext } from './PhotoViewerCarousel.context'
import { findNextPhotoId } from '../function/findNextPhotoId'

export const PhotoViewerArrow: FC<{
  isShowArrow: boolean
  onScrollToNextPhoto: (direction: NumberDirection) => void
}> = ({ isShowArrow, onScrollToNextPhoto }) => {
  const { photos, currentIndex, photoBaseUrl } = usePhotoViewerContext()
  const [leftUrl, rightUrl] = useMemo(() => {
    const leftPhotoId = findNextPhotoId(
      photos,
      currentIndex,
      NumberDirection.left
    )
    const rightPhotoId = findNextPhotoId(
      photos,
      currentIndex,
      NumberDirection.right
    )
    return [
      mergeAllUrls(photoBaseUrl, leftPhotoId),
      mergeAllUrls(photoBaseUrl, rightPhotoId),
    ]
  }, [photoBaseUrl, currentIndex, photos])

  const handleLeft = useCallback(
    (event: MouseEvent) => {
      fullStopPropagation(event)
      onScrollToNextPhoto(NumberDirection.left)
    },
    [onScrollToNextPhoto]
  )

  const handleRight = useCallback(
    (event: MouseEvent) => {
      fullStopPropagation(event)
      onScrollToNextPhoto(NumberDirection.right)
    },
    [onScrollToNextPhoto]
  )

  return (
    <Arrows
      isShow={true}
      isArrowLeftShow={isShowArrow}
      isArrowRightShow={isShowArrow}
      arrowLeft={<ArrowLeft href={leftUrl} onMoveLeft={handleLeft} />}
      arrowRight={<ArrowRight href={rightUrl} onMoveRight={handleRight} />}
    />
  )
}
